export const verificarTokenAutenticacao = () => {
    
    const cookie = document.cookie.split('; ').find(token => token.startsWith ('authGesttor'))

    if (!cookie) {
        return  window.location.href = '/'
    } 
  
    const token = cookie.split('=')[1]

    return token

}

export const Autenticacao = () => {

    const cookie = document.cookie.split('; ').find(token => token.startsWith ('authGesttor'))

    if (!cookie) {
        
        return false
    }
    
    return true
}
